import React from 'react';

import {
  Avatar,
  makeStyles,
  NotificationsIcon,
  NotificationsNoneIcon,
  CheckCircleIcon,
  ListItemAvatar,
} from '@gogame/components';
import { useHover } from '@gogame/hooks-ts';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '32px',
  },
  avatar: {
    cursor: ({ isRead }) => (isRead ? 'default' : 'pointer'),
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: ({ isRead, hovered }) =>
      isRead
        ? theme.palette.divider
        : hovered
          ? 'transparent'
          : theme.palette.secondary.main,

    background: ({ isRead, hovered }) =>
      isRead
        ? theme.palette.background.paper
        : hovered
          ? theme.palette.action.hover
          : theme.palette.background.paper, //'rgba(33, 150, 243, 0.08)',

    color: ({ isRead }) =>
      isRead ? theme.palette.action.active : theme.palette.secondary.main, //'rgba(2, 136, 209, 1)',
  },
}));

export default ({ type, isRead, onClick }) => {
  const [ref, hovered] = useHover();
  const classes = useStyles({ type, isRead, hovered });
  let icon;
  if (isRead) {
    icon = <NotificationsNoneIcon />;
  } else {
    if (hovered) {
      icon = <CheckCircleIcon />;
    } else {
      icon = <NotificationsIcon />;
    }
  }
  return (
    <ListItemAvatar
      onClick={!isRead ? onClick : undefined}
      classes={classes.root}
      ref={ref}
    >
      <Avatar className={classes.avatar}>{icon}</Avatar>
    </ListItemAvatar>
  );
};
